<template>
    <div class="newsletter-signup">
        <form action="https://modernartsmidwest.us1.list-manage.com/subscribe/post?u=c655c2148f1bd0cf4da2a8d58&amp;id=05d512b43f"
            method="post"
            name="mc-embedded-subscribe-form"
            class="validate" 
            target="_blank" 
            novalidate
        >
            <h4>{{ heading }}</h4>
            <input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="Type your email address" required>
            <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button">
        </form>
    </div>
</template>

<script>
export default {
    name: "Newsletter",
    props: {
        heading: {
            type: String,
            required: true,
        },
    },
};

</script>

<style lang="scss">
</style>
